/* MAS custom sword builder: renders the option groups from the catalog JSON asset, keeps a running total,
   checks required options and adds two lines to the cart: the sword (every choice as a note, in English) and the
   matching price-list variant "Custom options for <builder> / $<total>.00", linked by the hidden note _mas_link.
   Price-list product k = <pricelist>-k covers $(k-1)*range+step .. $k*range. */
(function () {
  var form = document.getElementById('mas-builder');
  if (!form) return;

  var base = parseInt(form.dataset.base, 10) || 0;      // cents
  var step = 5, range = 1250;                           // overwritten from the catalog
  var plh = form.dataset.pricelist;
  var loc = (form.dataset.locale || 'en').toLowerCase();
  var addBtn = form.querySelector('.mas-add');

  function money(cents) {
    var fmt = form.dataset.money || '${{amount}}';
    var v = cents / 100;
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var s;
    if (key === 'amount_no_decimals') s = Math.round(v).toLocaleString('en-US');
    else if (key === 'amount_with_comma_separator') s = v.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    else if (key === 'amount_no_decimals_with_comma_separator') s = Math.round(v).toLocaleString('de-DE');
    else s = v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{.*?\}\}/, s);
  }

  function text(map) { return (map && (map[loc] || map.en)) || ''; }

  function node(tag, cls, textContent) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (textContent != null) e.textContent = textContent;
    return e;
  }

  function render(cat) {
    var imgBase = (form.dataset.catalogUrl || '').replace(/[^\/]*$/, '');
    var wrap = form.querySelector('.mas-groups');
    wrap.innerHTML = '';
    (cat.groups || []).forEach(function (g) {
      var fs = node('fieldset', 'mas-group mas-group--' + g.type);
      fs.dataset.key = g.key;
      fs.dataset.en = g.name.en;
      if (g.required) fs.dataset.required = '1';
      var lg = node('legend', 'mas-group__title', text(g.name));
      if (g.required) { var req = node('span', 'mas-req', '*'); req.setAttribute('aria-hidden', 'true'); lg.appendChild(req); }
      fs.appendChild(lg);
      if (g.help) fs.appendChild(node('p', 'mas-help', text(g.help)));
      var choices = (g.choices || []).filter(function (c) { return !c.hidden; });

      if (g.type === 'textarea') {
        var ta = node('textarea', 'mas-textarea');
        ta.name = 'mas_text_' + g.key; ta.rows = 3; ta.maxLength = 1000;
        ta.placeholder = form.dataset.txtPlaceholder || '';
        fs.appendChild(ta);
      } else if (g.type === 'select') {
        var sel = node('select', 'mas-select');
        sel.name = 'mas_' + g.key;
        if (g.required) sel.required = true;
        var o0 = node('option', null, form.dataset.txtSelect || '--'); o0.value = '';
        sel.appendChild(o0);
        choices.forEach(function (c) {
          var o = node('option', null, text(c.label) + (c.price > 0 ? ' (+' + money(c.price * 100) + ')' : ''));
          o.value = c.key; o.dataset.price = c.price; o.dataset.en = c.label.en;
          if (c.default) o.selected = true;
          sel.appendChild(o);
        });
        fs.appendChild(sel);
      } else {
        var box = node('div', 'mas-swatches');
        choices.forEach(function (c) {
          var lab = node('label', 'mas-swatch');
          var tip = text(c.tooltip);
          if (tip) lab.title = tip;
          var inp = document.createElement('input');
          inp.type = 'radio'; inp.name = 'mas_' + g.key; inp.value = c.key;
          inp.dataset.price = c.price; inp.dataset.en = c.label.en;
          if (c.default) inp.checked = true;
          var bx = node('span', 'mas-swatch__box');
          if (c.image) {
            var im = document.createElement('img');
            im.className = 'mas-swatch__img'; im.src = imgBase + 'mas-opt-' + c.image; im.alt = ''; im.loading = 'lazy';
            bx.appendChild(im);
          } else {
            bx.appendChild(node('span', 'mas-swatch__img mas-swatch__img--none'));
          }
          bx.appendChild(node('span', 'mas-swatch__label', text(c.label)));
          if (c.price > 0) bx.appendChild(node('span', 'mas-swatch__price', '+' + money(c.price * 100)));
          lab.appendChild(inp); lab.appendChild(bx);
          box.appendChild(lab);
        });
        fs.appendChild(box);
      }
      wrap.appendChild(fs);
    });
    wrap.removeAttribute('aria-busy');
  }

  function selections() {
    var out = { props: {}, total: 0, missing: [] };
    form.querySelectorAll('.mas-group').forEach(function (g) {
      var en = g.dataset.en;
      g.classList.remove('mas-group--missing');
      if (g.classList.contains('mas-group--textarea')) {
        var t = g.querySelector('textarea');
        if (t && t.value.trim()) out.props[en] = t.value.trim().slice(0, 1000);
        return;
      }
      var chosen = null;
      if (g.classList.contains('mas-group--select')) {
        var sel = g.querySelector('select');
        if (sel && sel.value) chosen = sel.options[sel.selectedIndex];
      } else {
        chosen = g.querySelector('input[type=radio]:checked');
      }
      if (!chosen) {
        if (g.dataset.required) out.missing.push(g);
        return;
      }
      out.props[en] = chosen.dataset.en;
      out.total += parseInt(chosen.dataset.price || '0', 10);
    });
    return out;
  }

  function renderTotals() {
    var s = selections();
    form.querySelector('.mas-options').textContent = money(s.total * 100);
    form.querySelector('.mas-total').textContent = money(base + s.total * 100);
  }

  function message(txt, isError) {
    var m = form.querySelector('.mas-message');
    m.textContent = txt || '';
    m.hidden = !txt;
    m.classList.toggle('mas-message--error', !!isError);
  }

  function optionsVariant(total) {
    if (total === 0) return Promise.resolve(null);
    if (total % step !== 0) return Promise.reject(new Error('price step'));
    var k = Math.ceil(total / range);
    return fetch('/products/' + plh + '-' + k + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('price list ' + k); return r.json(); })
      .then(function (p) {
        var title = '$' + total + '.00';
        var v = p.variants.filter(function (v) { return v.title === title; })[0];
        if (!v) throw new Error('no price ' + title);
        return v;
      });
  }

  function addToCart() {
    var s = selections();
    if (s.missing.length) {
      s.missing.forEach(function (g) { g.classList.add('mas-group--missing'); });
      s.missing[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      message(form.dataset.msgRequired, true);
      return;
    }
    addBtn.disabled = true;
    message(form.dataset.msgAdding, false);
    var link = 'mas' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    var props = {};
    Object.keys(s.props).forEach(function (k) { props[k] = s.props[k]; });
    props._mas_link = link;
    props._mas_options_total = '$' + s.total + '.00';
    var items = [{ id: parseInt(form.dataset.variant, 10), quantity: 1, properties: props }];

    optionsVariant(s.total)
      .then(function (v) {
        if (v) items.push({ id: v.id, quantity: 1, properties: { _mas_link: link, _mas_for: form.dataset.title } });
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (r) {
        if (!r.ok) return r.json().catch(function () { return {}; }).then(function (e) { throw new Error(e.description || ('HTTP ' + r.status)); });
        window.location.href = form.dataset.cartUrl || '/cart';
      })
      .catch(function (err) {
        addBtn.disabled = false;
        message(form.dataset.msgError + ' (' + err.message + ')', true);
      });
  }

  form.addEventListener('change', renderTotals);
  form.addEventListener('input', renderTotals);
  addBtn.addEventListener('click', addToCart);

  fetch(form.dataset.catalogUrl, { headers: { Accept: 'application/json' } })
    .then(function (r) { if (!r.ok) throw new Error('catalog ' + r.status); return r.json(); })
    .then(function (cat) {
      step = cat.pricelist_step || step;
      range = cat.pricelist_range || range;
      render(cat);
      renderTotals();
      addBtn.disabled = false;
    })
    .catch(function () {
      message(form.dataset.msgUnavailable, true);
      form.querySelector('.mas-groups').removeAttribute('aria-busy');
    });
})();
